module.exports = __webpack_public_path__ + "static/media/logo.914ce39a.svg";